<template>
  <div class="footer">
    <div class="footer-left">
      <div class="footer-left-title">汉川市综合产权交易平台</div>
      <div class="footer-left-ul">
        <ul>
          <li @click="goHomePage">首页</li>
          <!-- <li @click="goNewsCenter" >工作动态</li> -->
          <li @click="goProjectCenter">项目中心</li>
          <li @click="goBiddingHall">竞价大厅</li>
          <li @click="goProjectAnn">项目公告</li>
          <li @click="goRegulation">政策法规</li>
          <li @click="goContactUs">通知公告</li>
        </ul>
      </div>
    </div>
    <div class="footer-right">
      <div>联系我们</div>
      <div><i class="el-icon-location"></i> 地址：</div>
      <div>汉川市仙女大道龙家北湾东南侧约220米</div>
      <div><i class="el-icon-phone"></i> 电话：</div>
      <div>0712-8281092</div>
	  <div>技术支持：武汉芯达云谷大数据有限公司</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CQJYFooter",

  data() {
    return {};
  },

  mounted() {},

  methods: {
    goHomePage() {
      if (this.$route.path.indexOf("/homePage") !== -1) {
        return;
      }
      this.$router.push("/homePage");
    },
    goNewsCenter() {
      if (this.$route.path.indexOf("/newsCenter") !== -1) {
        return;
      }
      this.$router.push("/newsCenter");
    },
    goProjectCenter() {
      if (this.$route.path.indexOf("/projectCenter") !== -1) {
        return;
      }
      this.$router.push("/projectCenter");
    },
    goBiddingHall() {
      // if (this.$route.path.indexOf("/biddingHall") !== -1) {
      //   return
      // }
      // this.$router.push("/biddingHall");
      window.open("http://121.36.224.212:8019/login?redirect=%2Findex");
      // window.open("http://81.71.76.218:8019/login");

      // window.location.href="http://localhost/login?redirect=%2Findex";
    },
    goProjectAnn() {
      if (this.$route.path.indexOf("/projectAnn") !== -1) {
        return;
      }
      this.$router.push("/projectAnn");
    },
    goRegulation() {
      if (this.$route.path.indexOf("/regulation") !== -1) {
        return;
      }
      this.$router.push("/regulation");
    },
    goContactUs() {
      if (this.$route.path.indexOf("/contactUs") !== -1) {
        return;
      }
      this.$router.push("/contactUs");
    },
    goDocumentFile() {
      if (this.$route.path.indexOf("/documentFile") !== -1) {
        return;
      }
      this.$router.push("/documentFile");
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  background: #222222;
  padding: 27px 0 29px;
  color: #fff;
  // height: 227px;
  display: flex;
  font-size: 16px;
  .footer-left {
    border-right: 1px solid #494949;
    width: 65%;
    padding-left: 177px;
    padding-right: 74px;

    .footer-left-title {
      margin: 22px 0 45px;
      font-size: 30px;
    }

    .footer-left-ul {
      ul {
        display: flex;
        justify-content: space-between;
        li {
        }
        li:hover {
          color: #b50006;
          cursor: pointer;
        }
      }
    }
  }

  .footer-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 74px;
    > div {
      margin-top: 17px;
    }
    div:nth-child(1) {
      color: #b50006;
      cursor: pointer;
    }

    div:nth-child(4) {
      i {
        transform: translateY(1px);
      }
    }
    div:nth-child(2n) {
      color: #a8a8a8;
      font-size: 14px;
      i {
        font-size: 12px;
      }
    }
  }
}
</style>